// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","rotation":"Loader_rotation__zW3DX","use_mask":"Loader_use_mask__nqzOP"};